import { Alert } from "@mui/material";
import { FormikErrors, useFormikContext } from "formik";
import omit from "lodash-es/omit";
import { useRef, useState, useEffect, ReactElement } from "react";

export const submitErrorField = "_submitError";

export default function FormikErrorBanner<
  Values extends { [submitErrorField]: unknown } = any,
>({
  renderBanner = () => "Please fix the errors indicated below.",
  noScrollOnError = false,
}: {
  renderBanner?: (errors: FormikErrors<Values>) => string | ReactElement;
  noScrollOnError?: boolean;
} = {}): ReactElement {
  const { submitCount, errors } = useFormikContext<{
    [submitErrorField]: unknown;
  }>();
  const isValid = Object.keys(omit(errors, submitErrorField)).length === 0;
  const lastHandledRef = useRef(0);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (submitCount > lastHandledRef.current && !isValid) {
      lastHandledRef.current = submitCount;
      if (!noScrollOnError) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      setShowBanner(true);
    }

    if (isValid) {
      setShowBanner(false);
    }
  }, [submitCount, isValid, noScrollOnError]);

  return (
    <div>
      {errors[submitErrorField] && (
        <Alert severity="error" sx={{ marginBottom: 3 }}>
          {errors[submitErrorField]}
        </Alert>
      )}
      {showBanner ? (
        <Alert severity="error" sx={{ marginBottom: 3 }}>
          {renderBanner(
            errors as FormikErrors<Values> & { [submitErrorField]: unknown }
          )}
        </Alert>
      ) : null}
    </div>
  );
}
